import { concat } from "lodash";

/**
 * Returns a depth-first ordered list of IDs in a tree
 * @param {TreeRecord} tree
 */
const getIdsInTree = tree => {
  const nestedChildIds = tree.children.reduce((arr, child) => {
    const cArr = getIdsInTree(child);
    return concat(arr, cArr);
  }, []);

  return tree.id ? concat([tree.id], nestedChildIds) : nestedChildIds;
};

export default getIdsInTree;
